import styled, { css } from 'styled-components';

export const StyledNotifications = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
`;

export const StyledFilterNameLabel = styled.label`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-bottom: 6px;
`;

const inputVariants = {
  true: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `,
  false: css`
    border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  `
};
export const StyledFilterNameInput = styled.input`
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};

  ${props => inputVariants[!!props.hasError]}

  &:placeholder {
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  }
`;
export const StyledNotificationsToggle = styled.div`
  button {
    margin-left: 18px;
  }
`;

export const StyledError = styled.div`
  color: ${({ theme }) => theme.COLORS.ERROR};
`;

export const StyledApplyMessage = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
`;
